/**
 * Event properties allowed onto Sentry metrics as attributes.
 *
 * Deny-by-default: only low-cardinality, non-PII, event-moment dimensions that
 * cannot be reconstructed from a database query are kept. Everything else —
 * entity ids, descriptive fields derivable via those ids, names, tokens, urls,
 * and the acting user id — is dropped, because it is DB-derivable, sensitive,
 * or would explode metric cardinality. Slicing and attribution are done via DB
 * queries, not Sentry.
 *
 * Backend services pass their own allowlist; this is the default both runtime
 * clients fall back to.
 */
const DEFAULT_ALLOWED_ATTRIBUTES = Object.freeze([
  "render_type", // design_render: export format (pdf/png/jpg/gif)
  "crop_and_bleed", // design_render: boolean
  "gif_speed", // design_render: gif-only speed setting
  "source", // add_page: which UI affordance (mobile panel vs button)
  "category_name", // category_view: browsed size/category (no persisted row)
  "page_name" // page_view: readable route label for page-view trends
]);

module.exports = DEFAULT_ALLOWED_ATTRIBUTES;
